import Vue from 'vue'

//设置localstorage
Vue.prototype.$setLocalStorage = (key,val)=>{
	if(window.localStorage){
		let storage = window.localStorage;
		storage.setItem(key,JSON.stringify(val));
	}else{
		console.error('当前浏览器不支持LocalStorage');
	}
};
//获取localstorage
Vue.prototype.$getLocalStorage = (key)=>{
	if(window.localStorage){
		let storage = window.localStorage;
		return JSON.parse(storage.getItem(key));
	}else{
		console.error('当前浏览器不支持LocalStorage');
	}
};
//删除localstorage
Vue.prototype.$delLocalStorage = (key)=>{
	if(window.localStorage){
		let storage = window.localStorage;
		storage.removeItem(key);
	}else{
		console.error('当前浏览器不支持LocalStorage');
	}
};
//设置sessionStorage
Vue.prototype.$setSessionStorage = (key,val)=>{
	if(window.sessionStorage){
		let storage = window.sessionStorage;
		storage.setItem(key,JSON.stringify(val));
	}else{
		console.error('当前浏览器不支持SessionStorage');
	}
};
//获取sessionStorage
Vue.prototype.$getSessionStorage = (key)=>{
	if(window.sessionStorage){
		let storage = window.sessionStorage;
		if(storage.getItem(key)) {
			return JSON.parse(storage.getItem(key));
		}else {
			return storage.getItem(key);
		}
	}else{
		console.error('当前浏览器不支持SessionStorage');
	}
};
//删除localstorage
Vue.prototype.$delSessionStorage = (key)=>{
	if(window.sessionStorage){
		let storage = window.sessionStorage;
		storage.removeItem(key);
	}else{
		console.error('当前浏览器不支持SessionStorage');
	}
};
///清空对象
Vue.prototype.$resert = (obj,resouce)=>{
	function res(objs){
		if(Array.isArray(objs)){
			objs.splice(0);
		}else if(typeof objs == 'boolean'){
			objs = false;
		}else if(objs instanceof Object){
			objs = new obj();
		}else{
			objs = '';
		}
		return objs;
	};

	for(let i in obj){
		if(resouce && resouce[i]){
			if(resouce[i]){
				obj[i] = resouce[i];
			}else{
				obj[i] = res(obj[i]);
			}
			//obj = Object.assign({},obj,resouce);
		}else{
			obj[i] = res(obj[i]);
		}
	}
	return obj;
};
Vue.prototype.$deepClone=(obj)=>{
	if(!obj) return;
	return JSON.parse(JSON.stringify(obj));
}
//格式化时间
Vue.prototype.$formart = (key, formart) => {
	let foms = formart || 'yyyy-MM-dd';
	var t = new Date(key);

	var y = t.getFullYear();
	var M = zero(t.getMonth() + 1);
	var d = zero(t.getDate());
	var h = zero(t.getHours());
	var m = zero(t.getMinutes());
	var s = zero(t.getSeconds());

	foms = foms.replace('yyyy', y);
	foms = foms.replace('MM', M);
	foms = foms.replace('dd', d);
	foms = foms.replace('hh', h);
	foms = foms.replace('mm', m);
	foms = foms.replace('ss', s);
	if (key != '' && key != null && key) {
		return foms;
	} else {
		return '';
	}
	function zero(val) {
		let v = val < 10 ? '0' + val : val;
		return v;
	};
};



// WEBPACK FOOTER //
// ./src/assets/utils/function.js